/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as GraphDefs from '../graph/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'app.bsky.notification.listNotifications'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  reasons: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  priority: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  seenAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  notifications: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Notification>((() => notification) as any),
  ),
  priority: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  seenAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerate notifications for the requesting account. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type Notification = {
  $type?: 'app.bsky.notification.listNotifications#notification'
  uri: l.AtUriString
  cid: l.CidString
  author: ActorDefs.ProfileView

  /**
   * The reason why this notification was delivered - e.g. your post was liked, or you received a new follower.
   */
  reason:
    | 'like'
    | 'repost'
    | 'follow'
    | 'mention'
    | 'reply'
    | 'quote'
    | 'starterpack-joined'
    | 'verified'
    | 'unverified'
    | 'like-via-repost'
    | 'repost-via-repost'
    | 'subscribed-post'
    | 'contact-match'
    | l.UnknownString
  reasonSubject?: l.AtUriString
  record: l.LexMap

  /**
   * The starter pack associated with this notification. Present when the notification is for a follow originating from a starter pack.
   */
  starterPack?: GraphDefs.StarterPackViewBasic
  isRead: boolean
  indexedAt: l.DatetimeString
  labels?: LabelDefs.Label[]
}

export type { Notification }

const notification = /*#__PURE__*/ l.typedObject<Notification>(
  $nsid,
  'notification',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    author: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    reason: /*#__PURE__*/ l.string<{
      knownValues: [
        'like',
        'repost',
        'follow',
        'mention',
        'reply',
        'quote',
        'starterpack-joined',
        'verified',
        'unverified',
        'like-via-repost',
        'repost-via-repost',
        'subscribed-post',
        'contact-match',
      ]
    }>(),
    reasonSubject: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    record: /*#__PURE__*/ l.lexMap(),
    starterPack: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<GraphDefs.StarterPackViewBasic>(
        (() => GraphDefs.starterPackViewBasic) as any,
      ),
    ),
    isRead: /*#__PURE__*/ l.boolean(),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
  }),
)

export { notification }
